var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-4{fill:none;stroke:#00d6c3;stroke-width:3px;}.cls-1,.cls-4{stroke-miterlimit:16.67;}.cls-2,.cls-4{stroke-linecap:round;}.cls-2{stroke-linejoin:round;}.cls-3{fill:#00d6c3;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Front"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 1.5,
    y: 1.5,
    width: 47,
    height: 47,
    rx: 5.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.32,21.44V37.11"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 14.32,
    cy: 13.61,
    r: 2.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M35.68,37.11V27.85a6.41,6.41,0,0,0-6.41-6.41h0a6.41,6.41,0,0,0-6.41,6.41v9.26"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedn);
export default __webpack_public_path__ + "static/media/linkedn.b941d8be4fba38ad327283944dd96b10.svg";
export { ForwardRef as ReactComponent };